
import TimeCountdown from '@/components/TimeCountdown'
import TitleBox from '@/components/CSS/TitleBox'
import { mapGetters } from 'vuex'
export default {
    components: {
        TimeCountdown,
        TitleBox
    },
    computed: {
        ...mapGetters(['config'])
    },
    data() {
        return {
            logoSrc: 'https://oss.pzds.com/imgv2/20211223100751.png',
            qrUrl: '',
            id: null,
            showInput: null,
            checkNumber: null,
            typeIndex: 0,
            // 充值金额
            numberData: [
                {
                    num: '500元',
                    price: 500
                },
                {
                    num: '800元',
                    price: 800
                },
                {
                    num: '1000元',
                    price: 1000
                },
                {
                    num: '1500元',
                    price: 1500
                }
            ],
            // 充值方式
            typeData: [
                {
                    type: 'ALIPAY',
                    name: '支付宝'
                }
                // {
                //   type: 2,
                //   name: '微信'
                // }
            ],
            action: {
                amount: null, // 充值金额
                payType: null // 充值方式
            },
            fullscreenLoading: false, // 加载Loading
            centerDialogVisible: false, // 支付二维码模态窗状态
            payForm: {}, // 支付信息
            timers: null,
            qrError: false,
            qrCodeLoading: false,
            submitLoading: false,
            pollingTime: null
        }
    },
    methods: {
        showInputHandler() {
            this.checkNumber = null
            if (!this.showInput) {
                this.showInput = true
                this.$nextTick(() => {
                    this.$refs['amount'].focus()
                })
            }
        },
        // 选择支付金额事件
        getNumberActive(val) {
            if (this.showInput) {
                this.showInput = null
            }
            if (this.checkNumber === val) {
                this.checkNumber = null
            } else {
                this.checkNumber = val
            }
        },
        // 选择支付方式事件
        geTypeActive(t) {
            this.typeIndex = t
        },
        // 确认充值事件
        submitForm() {
            if (this.checkNumber === null && this.action.amount === null) {
                this.$message.warning('请选择金额或点击其他金额进行输入')
                return
            }
            //   let amount = null;
            //   amount =
            //     this.checkNumber !== null
            //       ? this.numberData[this.checkNumber].price
            //       : parseFloat(this.action.amount);
            if (this.checkNumber) {
                this.action.amount = this.checkNumber
            }
            // 充值最高金额
            if (this.action.amount > this.config[this.$enum.CONFIG.config_9]) {
                let html
                if (/^http/.test(this.config[this.$enum.CONFIG.config_4]) || /^http/.test(this.config[this.$enum.CONFIG.config_5])) {
                    html = '<strong class="text-F7423F">目前线上充值仅支持5000元内,请点击立即咨询联系专属客服进行充值</strong>'
                } else {
                    html = `<strong class="text-F7423F">目前线上充值仅支持5000元内,请点击立即咨询联系专属客服进行充值</strong><br/>客服联系<strong>QQ：${
                        this.config[this.$enum.CONFIG.config_4]
                    }</strong>，若无法跳转请手动添加客服账号。<br/><strong class="text-F7423F">官方唯一收款支付宝：${this.config[this.$enum.CONFIG.config_5]}</strong>`
                }
                this.$alert(html, '充值超额', {
                    confirmButtonText: '立即咨询',
                    dangerouslyUseHTMLString: true,
                    type: 'warning'
                }).then(() => {
                    window.open(this.config[this.$enum.CONFIG.config_6])
                })
                return
            }
            this.fullscreenLoading = true
            const par = {
                action: {
                    amount: parseFloat(this.action.amount),
                    payType: 'ALIPAY'
                }
            }
            this.$api.payRecharge(par).then((res) => {
                if (res.success) {
                    this.$store.dispatch('user/UserGetInfo')
                    setTimeout(() => {
                        this.payForm = res.data
                        this.$nextTick(() => {
                            //   this.crateQrcode(res.data.qrCodeUrl);
                            this.qrUrl = res.data.qrCodeUrl
                        })
                        this.centerDialogVisible = true
                        // 启动轮询
                        this.pollingTime = setInterval(() => {
                            this.getPayOrderPayStatus(this.payForm.rechargeOrderNo)
                        }, 3000)
                    }, 1000)
                } else {
                    this.$message.error(res.info)
                    this.fullscreenLoading = false
                    // this.$nextTick(() => {
                    //   this.$refs["amount"].focus();
                    // });
                }
            })
        },
        // 获取充值订单支付状态
        getPayOrderPayStatus(rechargeOrderNo) {
            let _this = this
            let params = {
                action: {
                    rechargeOrderNo: rechargeOrderNo
                }
            }
            this.$api.getPayStatus(params).then((res) => {
                if (res.success) {
                    let data = res.data
                    if (!data) return
                    if (data.payStatus === 'PAY_SUCCESS') {
                        _this.fullscreenLoading = false
                        _this.centerDialogVisible = false
                        clearInterval(_this.pollingTime) // 清除定时器
                        if (_this.$route.query.toPay) {
                            _this.$router.go('-1')
                        } else {
                            // 回到个人中心
                            _this.$message.success('充值成功', 2, () => {
                                _this.$router.push('/account')
                            })
                        }
                        // 回调到支付页面
                        // if(this.id){
                        //     this.$router.push({
                        //         name: "orderPayment",
                        //         query: {
                        //             id: this.id
                        //         }
                        //     });
                        // } else {
                        //     this.$router.go(-1)
                        // }
                        return
                    }
                    if (data.payStatus === 'PAY_CLOSE') {
                        _this.centerDialogVisible = false
                        _this.fullscreenLoading = false
                        _this.$message.warning('充值已关闭')
                        clearInterval(_this.pollingTime) // 清除定时器
                        return
                    }
                    if (data.payStatus !== 'PAY_PENDING') {
                        this.$message.error(res.info)
                    }
                }
            })
        },

        // setQr() {
        //   this.pollingTime = setInterval(() => {
        //     this.getPayOrderPayStatus(this.ruleForm.pzdsOrderNo);
        //   }, 3000)
        //   this.getPayqrCodeUrl();

        //   // 30分钟没动就不调用支付接口
        //   setTimeout(() => {
        //     this.qrCodeLoading = true;
        //     clearInterval(this.pollingTime)
        //   }, 180000)
        // },
        countDowmEnd() {
            this.closeDialogVisible()
            this.qrError = true
        },
        debounce(fn, wait = 300) {
            let timer
            return function () {
                let _this = this
                let args = arguments
                if (timer) {
                    clearTimeout(timer)
                }
                timer = setTimeout(function () {
                    fn.apply(_this, args)
                }, wait)
            }
        },
        getQrCode() {
            this.closeDialogVisible()
            let _this = this
            this.debounce(_this.getPayqrCodeUrl())
        },
        // 重新获取二维码
        getPayqrCodeUrl() {
            console.log('this.action.amount', this.action.amount)
            let data = {
                action: {
                    amount: this.action.amount,
                    payType: 'ALIPAY'
                }
            }
            this.qrCodeLoading = true
            this.$api
                .payRecharge(data)
                .then((res) => {
                    this.qrError = false
                    if (res.success) {
                        this.timers = new Date().getTime()
                        // this.$refs.qrcode.innerHTML = "";
                        this.qrCodeLoading = false
                        this.$nextTick(() => {
                            this.qrUrl = res.data.qrCodeUrl
                        })
                    }
                })
                .catch(() => {
                    this.qrCodeLoading = false
                })
        },
        // 创建二维 码
        crateQrcode(qrCodeUrl) {
            this.qr = new QRCode('qrcode', {
                width: 150,
                height: 150, // 高度
                text: qrCodeUrl // 二维码内容
            })
        },
        closeDialogVisible() {
            let _this = this
            this.fullscreenLoading = false
            clearInterval(_this.pollingTime)
        }
    },
    created() {
        this.id = this.$route.query.id
        this.$store.dispatch('AppPublicConfig')
    },
    destroyed() {
        let _this = this
        clearInterval(_this.pollingTime)
    }
}
